module.exports = __webpack_public_path__ + "assets/img/mouse.30940da6.png";